import moment from "moment";
import { globalInvoiceStatusTypes } from "./types";

const { HANDLE_GLOBAL_INVOICE_STATUS_INPUTS, GET_GLOBAL_INVOICE_STATUS } =
  globalInvoiceStatusTypes;

const initialState = {
  date: moment(new Date()).format("YYYY-MM"),
  station: null,
  invoices: [],
};

export const globalInvoiceStatusReducer = (
  state = initialState,
  { type, payload } = {},
) => {
  switch (type) {
    case HANDLE_GLOBAL_INVOICE_STATUS_INPUTS:
      return { ...state, [payload.key]: payload.value };
    case GET_GLOBAL_INVOICE_STATUS:
      return { ...state, invoices: payload || [] };
    default:
      return state;
  }
};
